module.exports = __webpack_public_path__ + "img/box-packaging@1x.3ae97ef1.png";